(function() {
    'use strict';

    angular
        .module('soopkitchenApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'angularConsent',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'jsonFormatter',
            'daterangepicker'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();
